import { render, staticRenderFns } from "./AssignRulesTimeSeries.vue?vue&type=template&id=1056a495&"
import script from "./AssignRulesTimeSeries.vue?vue&type=script&lang=ts&"
export * from "./AssignRulesTimeSeries.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRulesTimeSeries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports